var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 140,
    viewBox: "0 0 142 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9999 139.977C109.55 139.977 141.015 108.585 141.015 70.035C141.015 31.485 109.55 0.0224609 70.9999 0.0224609C32.4499 0.0224609 0.984863 31.4875 0.984863 70.0375C0.984863 108.587 32.4499 139.977 70.9999 139.977Z",
    fill: "url(#paint0_linear_409_303)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6873 92.1649C65.0473 92.1649 64.4098 91.9199 63.9223 91.4349L41.3148 68.8999C40.3373 67.9249 40.3348 66.3449 41.3098 65.3649C42.2848 64.3849 43.8648 64.3874 44.8448 65.3599L65.6848 86.1324L103.245 48.5674C104.222 47.5899 105.802 47.5899 106.78 48.5674C107.757 49.5449 107.757 51.1249 106.78 52.1024L67.4548 91.4324C66.9673 91.9224 66.3273 92.1649 65.6873 92.1649Z",
    fill: "url(#paint1_linear_409_303)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_409_303",
    x1: 0.984863,
    y1: 70.0031,
    x2: 141.015,
    y2: 70.0031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8D5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_409_303",
    x1: 40.5815,
    y1: 69.9975,
    x2: 107.517,
    y2: 69.9975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1505,
    stopColor: "#A8D5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FCF4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.6c8955c3.svg";
export { ForwardRef as ReactComponent };